import {Component, Inject, Optional} from '@angular/core';
import {Compbaser} from "../compbaser";
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";

export interface IDialogAiResourceData {
  mediaTypeFilter?: 'image' | 'video' | 'both';
}

@Component({
  selector: 'app-dialog-ai-resource',
  templateUrl: './dialog-ai-resource.component.html',
  styleUrls: ['./dialog-ai-resource.component.scss']
})
export class DialogAiResourceComponent extends Compbaser {

  titleString = '';
  icon = 'auto_awesome';
  mediaTypeFilter: 'image' | 'video' | 'both' = 'both';

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: IDialogAiResourceData,
    protected override dialog: MatDialog,
    private translocoService: TranslocoService
  ) {
    super(dialog);
    this.titleString = this.translocoService.translate('ai.generateAIBackground', {}, this.translocoService.getActiveLang());

    if (data?.mediaTypeFilter) {
      this.mediaTypeFilter = data.mediaTypeFilter;
    }
  }
}